module.exports = __webpack_public_path__ + "img/迪士尼.8f655dbc.png";